export interface Category {
  id: string;
  nameRu: string;
  nameEn: string;
  url: string;
  icon: string;
}

export const categories: Category[] = [
  {
    id: 'shoes',
    nameRu: 'Обувь',
    nameEn: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
  },
  {
    id: 'hoodies',
    nameRu: 'Худи / Свитера',
    nameEn: 'Hoodies/Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-t-shirt-line',
  },
  {
    id: 'tshirts',
    nameRu: 'Футболки',
    nameEn: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-checkbox-blank-circle-line',
  },
  {
    id: 'jackets',
    nameRu: 'Куртки',
    nameEn: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-cloudy-line',
  },
  {
    id: 'pants',
    nameRu: 'Брюки / Шорты',
    nameEn: 'Pants/Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-pantone-line',
  },
  {
    id: 'headwear',
    nameRu: 'Головные уборы',
    nameEn: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-customer-service-line',
  },
  {
    id: 'sets',
    nameRu: 'Комплекты',
    nameEn: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
  },
  {
    id: 'underwear',
    nameRu: 'Нижнее бельё',
    nameEn: 'Underwear/Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-contrast-drop-line',
  },
  {
    id: 'jersey',
    nameRu: 'Джерси',
    nameEn: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-shirt-line',
  },
  {
    id: 'accessories',
    nameRu: 'Аксессуары',
    nameEn: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-vip-diamond-line',
  },
  {
    id: 'bags',
    nameRu: 'Сумки',
    nameEn: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-briefcase-line',
  },
  {
    id: 'belts',
    nameRu: 'Ремни',
    nameEn: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-link',
  },
  {
    id: 'perfumes',
    nameRu: 'Парфюмерия',
    nameEn: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-drop-line',
  },
  {
    id: 'other',
    nameRu: 'Прочее',
    nameEn: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
  },
];